import React, { useState, useEffect, useMemo, useRef } from 'react'
import { DebounceInput } from 'react-debounce-input';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../Actions/AllAction';
import { withTranslation } from 'react-i18next';
import { hotelList } from '../Controller/SupportUserController';



function AssignBusinessModalContent(props) {
    const [businessList, setBusinessList] = useState([]);
    const [assignBusinessOffset, setAssignBusinessOffset] = useState(0);
    const [assignBusinessLimit, setAssignBusinessLimit] = useState(10);
    const [hasMoreAssignBusinessList, setHasMoreAssignBusinessList] = useState(true)
    const [searchValue, setSearchValue] = useState(''); // New state for search input
    const assignBusinessContentRef = useRef(true);
    const [pageRefresh, setPageRefresh] = useState(false);
    const [assignBusinessStatus, setAssignBusinessStatus] = useState(false);
    const [clearglobalbookingSearchData, setClearGlobalbookingSearchData] = useState(false);
    const [previousSelectedBusinessList, setPreviousSelectedBusinessList] = useState([]);
    const [selectAllBusiness, setSelectAllBusiness] = useState(false);
    const [selectAllBusinessOnlyAction, setSelectAllBusinessOnlyAction] = useState(false);
    const [isFirstTime, setIsFirstTime] = useState(true);
    const assignBusinessRef = useRef(true);
    const [totalBusiness, setTotalBusiness] = useState(0);
    const [excludeId, setExcludeId] = useState([]);


    //set previously selected businss list
    useEffect(() => {
        if (props.selectedBusinessList.length > 0) {
            setPreviousSelectedBusinessList(props.selectedBusinessList);
        }
    }, [props.selectedBusinessList])

    //check business list from previous selected business list
    useEffect(() => {
        let selectedBusinessIds = previousSelectedBusinessList.length > 0
            ? new Set(previousSelectedBusinessList.map(business => business.id))
            : new Set();

        let updatedBusinessList = businessList.map((business) => ({
            ...business,
            check: selectAllBusiness ? true : selectedBusinessIds.has(business.id)
        }));
        setBusinessList(updatedBusinessList);
    }, [previousSelectedBusinessList]);


    useEffect(() => {
        if (assignBusinessContentRef.current) {
            assignBusinessContentRef.current = false;
            setSelectAllBusinessOnlyAction(props.selectAllBusinessOnlyAction)
            setSelectAllBusiness(props.selectAllBusiness);
            if (!props.selectAllBusinessOnlyAction) {
                setExcludeId(props.excludeId);
            }
            setTimeout(() => {
                assignBusinessListApiFn();
            }, 1000);
        }
    }, [props.selectAllBusiness, props.selectAllBusinessOnlyAction, props.excludeId]);

    //business data load fn
    const loadGrid = () => {
        setAssignBusinessOffset(0)
        setAssignBusinessLimit(12)
        setBusinessList([])
        setPageRefresh(true);
    }

    //search business onchange fn
    const handleSearchValue = (e) => {
        if (e.target.value != "") {
            setSearchValue(e.target.value)
        } else {
            setSearchValue("")
            setClearGlobalbookingSearchData(true)
        }
    }

    //when seatch value change useeffect trigger
    useEffect(() => {
        if (searchValue != "") {
            loadGrid();
        }
    }, [searchValue])

    //clear search value this useeffect call
    useEffect(() => {
        if (clearglobalbookingSearchData) {
            loadGrid();
        }
    }, [clearglobalbookingSearchData])


    //clear search value onchange fn
    const clearSearchValue = () => {
        setSearchValue("")
        setAssignBusinessOffset(0)
        setAssignBusinessLimit(12)
        setBusinessList([])
        setClearGlobalbookingSearchData(true)
    }

    //on scroll add more data 
    const getNextData = () => {
        if (assignBusinessOffset > 0) {
            assignBusinessListApiFn()
        }
    }

    //assign business list refresh
    useEffect(() => {
        if (pageRefresh) {
            assignBusinessListApiFn();
        }
    }, [pageRefresh])

    //assign business list api dataset formatting
    const formattingAssignBusinessListDataSetFn = (csvDownload = false) => {
        let filters = {};
        let filter_op = {};
        let globalQueryParamshash = {};

        if (!csvDownload) {
            globalQueryParamshash["limit"] = assignBusinessLimit.toString();
            globalQueryParamshash["offset"] = assignBusinessOffset.toString();
            globalQueryParamshash["sort_by_name"] = true;
            globalQueryParamshash["search_by"] = 'name';
            globalQueryParamshash["active"] = true;
        }
        if (csvDownload) {
            globalQueryParamshash["type"] = "csv"
        }
        let id = props.supportUserId;
        globalQueryParamshash["user_id"] = id;
        if (searchValue !== "") {
            globalQueryParamshash['search_attr'] = searchValue;
            filter_op = Object.assign(filter_op, { "search_attr": "substring" });
        }
        if (Object.keys(filter_op).length > 0) {
            filters["filter_op"] = JSON.stringify(filter_op);
        }
        filters['filters'] = JSON.stringify(globalQueryParamshash);

        return filters;
    }

    //assign business list api call
    const assignBusinessListApiFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let promise = new Promise((resolve, reject) => {
            setIsFirstTime(false)
            setAssignBusinessStatus(false)
            loaderStateTrue();
            let filters = formattingAssignBusinessListDataSetFn();
            hotelList(filters).then((response) => {
                if (response.success) {
                    setTotalBusiness(response.total)
                    resolve(response)
                } else {
                    setAssignBusinessStatus(true)
                }
                loaderStateFalse();
                setPageRefresh(false);
                setClearGlobalbookingSearchData(false)
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {

                }
                loaderStateFalse();
                setAssignBusinessStatus(true)
                if (error.message == "Network Error") {
                }
            });

        })
        promise.then((res) => {
            if (res.total > 0 || res.data.length > 0) {
                setHasMoreAssignBusinessList(true)
                if (assignBusinessOffset <= res.total) {
                    let tempOffset = assignBusinessOffset + assignBusinessLimit
                    setAssignBusinessOffset(tempOffset)
                    let tempAllBookingRoomData = businessList.slice();
                    let responseData = res.data;
                    if (responseData.length > 0) {

                        let selectedBusinessIds = props.selectedBusinessList.length > 0
                            ? new Set(props.selectedBusinessList
                                .filter(business => business.check === true)
                                .map(business => business.id))
                            : new Set();
                        if (selectAllBusinessOnlyAction) {
                            responseData = responseData.map(el => {
                                return {
                                    ...el,
                                    check: true
                                };
                            });
                        } else {
                            responseData = responseData.map(el => {
                                return {
                                    ...el,
                                    check: props.selectAllBusiness && isFirstTime ? true : props.selectAllBusiness ? true : selectedBusinessIds.has(el.id)
                                };
                            });
                        }
                    }
                    responseData = responseData.map(el => {
                        return {
                            ...el,
                            check: props.excludeId.length > 0 && props.excludeId.includes(el.id) ? false : el.check
                        };
                    });
                    if (selectAllBusiness) {
                        setPreviousSelectedBusinessList([...previousSelectedBusinessList, ...responseData]);
                    }
                    let finalBookingRoomData = tempAllBookingRoomData.concat(responseData)
                    setTimeout(() => {
                        setBusinessList(finalBookingRoomData)
                        setAssignBusinessStatus(true)
                    }, 500)
                } else {
                    setHasMoreAssignBusinessList(false)
                    setTimeout(() => {
                        setAssignBusinessStatus(true)
                    }, 500)
                }
                if (res.data.length == 0) {
                    setHasMoreAssignBusinessList(false)
                    setTimeout(() => {
                        setAssignBusinessStatus(true)
                    }, 500)
                }
            } else {
                setHasMoreAssignBusinessList(false)
                setTimeout(() => {
                    setAssignBusinessStatus(true)
                }, 500)
            }
        })
    }




    useEffect(() => {
    }, [excludeId, businessList])

    //edit mode business id array formatting
    const toggleValueInArray = (array, value) => {
        // Check if the value exists in the array
        if (array.includes(value)) {
            // If the value exists, remove it using filter
            return array.filter(item => item !== value);
        } else {
            // If the value doesn't exist, push it to the array
            return [...array, value]; // Return a new array with the value added
        }
    };

    //check business checkbox onchange fn
    const selectBusinessId = (e, businessId, business) => {
        const isChecked = e.target.checked;
        const updatedList = businessList.map((item) => {
            if (item.id === businessId) {
                return {
                    ...item,
                    check: isChecked,
                };
            }
            return item;
        });

        if (!isChecked) {
            if (selectAllBusinessOnlyAction) {
                setExcludeId([...excludeId, businessId])
                props.setExcludeId([...props.excludeId, businessId])
            }

            setSelectAllBusiness(false);
        } else {
            if (selectAllBusinessOnlyAction) {
                setExcludeId(prevState => prevState.filter(item => item !== businessId));
                props.setExcludeId(prevState => prevState.filter(item => item !== businessId));
            }
        }


        if (props.editedFlag) {
            let includeId = props.includeId;
            let includesArrIdModefy = toggleValueInArray(includeId, businessId)
            props.setincludeId(includesArrIdModefy);
        }

        setBusinessList(updatedList);

    };

    useEffect(() => {
        if (selectAllBusinessOnlyAction && excludeId.length == 0) {
            setSelectAllBusiness(true);
        }
    }, [excludeId])

    //save assign business list callback fn
    const saveAssignBusinessFn = () => {
        props.closeAssignBusinessListModal('save', businessList, selectAllBusiness, totalBusiness);
    };

     //close assign business list 
    const cancelAssignBusinessFn = () => {
        props.closeAssignBusinessListModal('close');
    };

    //select all business onchange fn
    const selectAllBusinessFn = (e) => {
        let updatedList = businessList.map((item) => {
            return {
                ...item,
                check: e.target.checked,
            };
        });
        setBusinessList(updatedList);
        if (e.target.checked) {
            setSelectAllBusiness(true);
            setSelectAllBusinessOnlyAction(true);
            props.setSelectAllBusinessOnlyAction(true);
            setExcludeId([])
            props.setExcludeId([])
            setPreviousSelectedBusinessList([...previousSelectedBusinessList, ...updatedList]);
        } else {
            setSelectAllBusiness(false);
            setSelectAllBusinessOnlyAction(false);
            props.setSelectAllBusinessOnlyAction(false);
            setPreviousSelectedBusinessList([]);
        }
        if (props.editedFlag) {
            if (!e.target.checked) {
                props.setincludeId([])
            }
        }

    }

    useEffect(() => {
    }, [selectAllBusinessOnlyAction])





    return (
        <div className="modalinnerbody assign_business_modal">
            <form id="busunessList">
                <div className="searchBoxBusunessList">
                    <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                    <DebounceInput
                        minLength={2}
                        debounceTimeout={500}
                        onChange={handleSearchValue} // Update search handler
                        placeholder="Search..."
                        value={searchValue} // Bind value to search input
                        autoComplete="off"
                    />
                    {searchValue !== "" ? (
                        <button type="button" className="btn btn-link dropclosebtn" onClick={clearSearchValue}>
                            {/* Replace 'require' with the correct path to your image */}
                            <img src={require('../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" alt="Clear" />
                        </button>
                    ) : null}
                </div>
            </form>
            <div className="gridCheckBox gridCheckBoxSellectAll">
                <label className="chkContainer">
                    <input type="checkbox"
                        onClick={(e) => { selectAllBusinessFn(e) }}
                        checked={selectAllBusiness}
                    />
                    Select All
                    <span className="checkmark"></span>
                </label>
                {props.editedFlag ?
                    <label>{`${selectAllBusiness ? totalBusiness : props.includeId.length}/${totalBusiness}`}</label> :
                    <label>{`${selectAllBusiness ? totalBusiness : selectAllBusinessOnlyAction ? (excludeId.length >= totalBusiness ? 0 : totalBusiness - excludeId.length) : excludeId.length === 0 ? businessList.filter(business => business.check === true).length : 0}/${totalBusiness}`}</label>}
            </div>

            <div id="scrollableDiv" className="scrollableDiv" style={{ overflowY: "auto", position: 'relative' }}>
                <InfiniteScroll
                    dataLength={businessList.length}
                    next={getNextData}
                    hasMore={hasMoreAssignBusinessList}
                    loader={<div className="text-center"></div>}
                    scrollableTarget="scrollableDiv"
                >

                    <div className='businessCardBoxes businessCardBoxesForAssignBusiness'>
                        {businessList.map((business, index) => (
                            <div key={index} className="media businessCardBox">
                                <div className="media-left">
                                    <div className="gridCheckBox gridCheckBoxbusinessCard">
                                        <label className="chkContainer">
                                            <input
                                                type="checkbox"
                                                checked={business.check}
                                                onClick={(e) => selectBusinessId(e, business.id, business)}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="media-body">
                                    {business.hasOwnProperty('name') && business.name ? (
                                        <h5>
                                            <OverlayTrigger
                                                overlay={<Tooltip>{business.name}</Tooltip>}
                                            >
                                                {business.name.length > 50 ? (
                                                    <span>{business.name.substring(0, 47) + "..."}</span>
                                                ) : (
                                                    <span>{business.name}</span>
                                                )}
                                            </OverlayTrigger>
                                        </h5>
                                    ) : (
                                        <h5></h5>
                                    )}
                                    {/* <p>
                                        {business.org_type === "agency" ? (
                                            <span className="agency">Agency</span>
                                        ) : (
                                            <span className="hotel">Hotel</span>
                                        )}
                                    </p> */}
                                </div>
                            </div>
                        ))}
                    </div>

                </InfiniteScroll>
            </div>

            <div className="col-md-12 text-center topspace">
                <button type="button" className="modBtnSave" onClick={() => { saveAssignBusinessFn() }}>Save</button>
                <button type="button" className="modBtnSave cancelbtn" onClick={() => { cancelAssignBusinessFn() }}>Cancel</button>
            </div>
        </div>
    );
}

AssignBusinessModalContent.defaultProps = {
    supportUserId: ''
}
const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}


export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withTranslation()(AssignBusinessModalContent));
